<template>
    <div>
        <div style="display:flex;display: none;">
            <!-- <div>
          <el-input v-model="searchArr.phone_order" placeholder="手机号/订单号" size="mini" clearable
            :loading="searchLoading" prefix-icon="el-icon-search">
          </el-input>
        </div> -->
            <div style="margin-left:0.2rem">
                <el-popover placement="bottom-start" width="500" ref="renewPopover" v-model="visible">
                    <el-form :model="searchArr" ref="searchForm" label-width="100px" style="margin-left:-0.3rem">
                        <!-- <el-form-item label="代理记账状态" prop="status">
                            <el-radio-group v-model="searchArr.status" size="mini">
                                <el-radio-button :label="1">服务中</el-radio-button>
                                <el-radio-button :label="2">本月到期</el-radio-button>
                                <el-radio-button :label="3">已经过期</el-radio-button>
                            </el-radio-group>
                        </el-form-item> -->
                        <!-- <el-form-item label="到期时间" prop="expire_date" id="expire_date">
                            <el-date-picker size="mini" v-model="searchArr.expire_date" type="datetimerange" align="right"
                                unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                                :picker-options="ysyTypeInPickerOptions" value-format="yyyy-MM-dd HH:mm:ss"
                                :default-time="['00:00:00', '23:59:59']">
                            </el-date-picker>
                        </el-form-item> -->
                        <el-form-item label="人员选择" prop="salesman_id">
                            <el-select v-model="searchArr.salesman_id" placeholder="请选择" filterable clearable size="mini"
                                multiple style="width: 100%;" @click.native="loadAdminUser">
                                <el-option v-for="user in adminUserOptions" :key="user.id" :label="user.username"
                                    :value="user.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <!-- <el-form-item label="共享人" prop="share_id">
                            <el-select v-model="searchArr.share_id" placeholder="请选择" filterable clearable size="mini"
                                multiable style="width: 100%;" @click.native="loadAdminUser" multiple>
                                <el-option v-for="user in adminUserOptions" :key="user.id" :label="user.username"
                                    :value="user.id"></el-option>
                            </el-select>
                        </el-form-item> -->
                        <!-- <el-form-item label="支付人/手机号" prop="payuser_id">
                <el-input v-model="searchArr.payuser_id" size="mini"
                  placeholder="支付人 / 手机号"></el-input>
              </el-form-item> -->
                        <!-- <el-form-item label="创建时间" prop="created_at">
                <el-date-picker size="mini" v-model="searchArr.created_at" type="datetimerange"
                  align="right" unlink-panels range-separator="至" start-placeholder="开始日期"
                  end-placeholder="结束日期" :picker-options="ysyTypeInPickerOptions"
                  value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']">
                </el-date-picker>
              </el-form-item> -->
                        <el-form-item style="text-align: right;margin-right:0.3rem">
                            <el-button @click="resetForm('searchForm')" size="mini">重置</el-button>
                            <el-button type="primary" @click="doSearch" size="mini">查询</el-button>
                        </el-form-item>
                    </el-form>
                    <el-button slot="reference" size="mini">筛选</el-button>
                </el-popover>
            </div>
            <!-- <div style="text-align: right; flex: 1">
          <el-button type="primary" size="mini" @click="categoryIn">录入</el-button>
        </div> -->
        </div>
        <!-- display: flex; -->
        <div style="display: none;font-size: medium;">
            <div class="count_title">
                累计收费价值:
            </div>
            <div class="count_content">
                {{ value }}元
            </div>
            <div class="count_title">
                已经过期:
            </div>
            <div class="count_content">
                {{ already_expired }}家
            </div>
            <div class="count_title">
                本月到期:
            </div>
            <div class="count_content">
                {{ this_month_expired }}家
            </div>
            <div class="count_title">
                今日续费:
            </div>
            <div class="count_content">
                {{ today_renew_count }}家
            </div>
            <div class="count_title">
                本月续费:
            </div>
            <div class="count_content">
                {{ this_month_renew_count_head }}家
            </div>
        </div>
        <el-table :data="serviceInData" style="width: 100%; margin-top: 10px" border size="mini" :header-cell-style="{
            background: '#ecf4ff',
            color: '#333',
            fontWeight: '900',
            fontSize: '0.28rem',
        }" max-height="650">
            <el-table-column prop="company.company_name" label="公司名称" width="280" fixed="left">
                <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" :content="scope.row.company.company_name" placement="top"
                        style="display:inline-block">
                        <el-link style="
                display: block;
                color: #409eff;
                font-size: 0.28rem;
                cursor: pointer;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              " @click="openCompanyCom(scope.row)">
                            {{ scope.row.company.company_name }}
                        </el-link>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="复制" placement="top"><i class="el-icon-document-copy"
                            style="margin-left: 0.1rem; cursor: pointer"
                            @click="copySome(scope.row.company.company_name)"></i></el-tooltip>
                </template>
            </el-table-column>
            <el-table-column prop="typeiner.username" label="创建人" width="150">
                <template slot-scope="scope">
                    <p>{{ scope.row.typeiner.username }}</p>
                    <p>{{ scope.row.created_at }}</p>
                </template>
            </el-table-column>
            <el-table-column prop="completed_at" label="ETA处理时间" width="280">
            </el-table-column>
            <el-table-column prop="donner.username" label="办理人" width="120">
                <!-- <template slot-scope="scope">
                    <div v-if="!scope.row.overTime">
                        <span v-if="!scope.row.donner">
                            <span>
                                <el-tooltip class="item" effect="dark" content="点击添加办理人" placement="top">
                                    <el-popover placement="left-start" width="300" trigger="click">
                                        <el-form :model="addAddressForm" :rules="addressRules" ref="addAddressForm"
                                            label-width="80px" style="padding-right: 0.33rem">
                                            <el-form-item label="办理人" prop="doner_id">
                                                <el-select v-model="addAddressForm.doner_id" placeholder="请选择" size="mini"
                                                    @click.native="loadAdminUser_a" filterable style="width: 100%"
                                                    clearable>
                                                    <el-option v-for="item in adminUserOptions_a" :key="item.id"
                                                        :label="item.username" :value="item.id">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-form>
                                        <div style="
                        margin-top: 0.15rem;
                        text-align: right;
                        padding-right: 0.33rem;
                      ">
                                            <el-button type="primary" size="mini"
                                                @click="saveChange('addAddressForm', scope.row.id)">保存
                                            </el-button>
                                        </div>
                                        <i slot="reference" style="
                        cursor: pointer;
                        font-size: 0.38rem;
                        color: #409eff;
                      " class="el-icon-circle-plus-outline"></i>
                                    </el-popover>
                                </el-tooltip>
                            </span>
                        </span>
                        <span v-else>
                            <span>
                                {{ scope.row.donner.username }}
                            </span>
                        </span>
                    </div>
                    <div v-if="scope.row.overTime">
                        <span v-if="!scope.row.donner">
                            <span>
                                <el-tooltip class="item" effect="dark" content="点击添加办理人" placement="top">
                                    <el-popover placement="left-start" width="300" trigger="click">
                                        <el-form :model="addAddressForm" :rules="addressRules" ref="addAddressForm"
                                            label-width="80px" style="padding-right: 0.33rem">
                                            <el-form-item label="办理人" prop="doner_id">
                                                <el-select v-model="addAddressForm.doner_id" placeholder="请选择" size="mini"
                                                    @click.native="loadAdminUser_a" filterable style="width: 100%"
                                                    clearable>
                                                    <el-option v-for="item in adminUserOptions_a" :key="item.id"
                                                        :label="item.username" :value="item.id">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-form>
                                        <div style="
                        margin-top: 0.15rem;
                        text-align: right;
                        padding-right: 0.33rem;
                      ">
                                            <el-button type="primary" size="mini"
                                                @click="saveChange('addAddressForm', scope.row.id)">保存
                                            </el-button>
                                        </div>
                                        <i slot="reference" style="
                        cursor: pointer;
                        font-size: 0.38rem;
                        color: #409eff;
                      " class="el-icon-circle-plus-outline"></i>
                                    </el-popover>
                                </el-tooltip>
                            </span>
                            <span>
                                <el-tooltip class="item" effect="dark" content="分配超时" placement="top">
                                    <i class="el-icon-warning" style="
                      font-size: 0.35rem;
                      color: #f56c6c;
                      margin-left: 0.25rem;
                    "></i>
                                </el-tooltip>
                            </span>
                        </span>
                        <span v-else>
                            <span>
                                {{ scope.row.donner.username }}
                            </span>
                            <span>
                                <el-tooltip class="item" effect="dark" content="分配超时" placement="top">
                                    <i class="el-icon-warning" style="
                      font-size: 0.35rem;
                      color: #f56c6c;
                      margin-left: 0.25rem;
                    "></i>
                                </el-tooltip>
                            </span>
                        </span>
                    </div>
                </template> -->
            </el-table-column>
            <el-table-column prop="donner_w.username" label="外勤办理人" width="120">
                <!-- <template slot-scope="scope">
                    <div v-if="!scope.row.overTime">
                        <span v-if="!scope.row.donner_w && scope.row.type === 'w'">
                            <span>
                                <el-tooltip class="item" effect="dark" content="点击添加办理人(外勤)" placement="top">
                                    <el-popover placement="left-start" width="300" trigger="click">
                                        <el-form :model="addAddressFormW" :rules="addressRules" ref="addAddressFormW"
                                            label-width="100px" style="padding-right: 0.31rem">
                                            <el-form-item label="办理人(外勤)" prop="doner_id_w">
                                                <el-select v-model="addAddressFormW.doner_id_w" placeholder="请选择"
                                                    size="mini" @click.native="loadAdminUser_a_w" filterable
                                                    style="width: 100%" clearable>
                                                    <el-option v-for="item in adminUserOptions_a_w" :key="item.id"
                                                        :label="item.username" :value="item.id">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-form>
                                        <div style="
                        margin-top: 0.15rem;
                        text-align: right;
                        padding-right: 0.31rem;
                      ">
                                            <el-button type="primary" size="mini"
                                                @click="saveChange_aw('addAddressFormW', scope.row.id)">保存
                                            </el-button>
                                        </div>
                                        <i slot="reference" style="
                        cursor: pointer;
                        font-size: 0.38rem;
                        color: #409eff;
                      " class="el-icon-circle-plus-outline"></i>
                                    </el-popover>
                                </el-tooltip>
                            </span>
                        </span>
                        <span v-if="scope.row.donner_w">{{
                            scope.row.donner_w.username
                        }}</span>
                    </div>
                    <div v-if="scope.row.overTime">
                        <span v-if="!scope.row.donner_w && scope.row.type === 'w'">
                            <span>
                                <el-tooltip class="item" effect="dark" content="点击添加办理人(外勤)" placement="top">
                                    <el-popover placement="left-start" width="300" trigger="click">
                                        <el-form :model="addAddressFormW" :rules="addressRules" ref="addAddressFormW"
                                            label-width="100px" style="padding-right: 0.31rem">
                                            <el-form-item label="办理人(外勤)" prop="doner_id_w">
                                                <el-select v-model="addAddressFormW.doner_id_w" placeholder="请选择"
                                                    size="mini" @click.native="loadAdminUser_a_w" filterable
                                                    style="width: 100%" clearable>
                                                    <el-option v-for="item in adminUserOptions_a_w" :key="item.id"
                                                        :label="item.username" :value="item.id">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-form>
                                        <div style="
                        margin-top: 0.15rem;
                        text-align: right;
                        padding-right: 0.31rem;
                      ">
                                            <el-button type="primary" size="mini"
                                                @click="saveChange_aw('addAddressFormW', scope.row.id)">保存
                                            </el-button>
                                        </div>
                                        <i slot="reference" style="
                        cursor: pointer;
                        font-size: 0.38rem;
                        color: #409eff;
                      " class="el-icon-circle-plus-outline"></i>
                                    </el-popover>
                                </el-tooltip>
                            </span>
                            <span>
                                <el-tooltip class="item" effect="dark" content="分配超时" placement="top">
                                    <i class="el-icon-warning" style="
                      font-size: 0.35rem;
                      color: #f56c6c;
                      margin-left: 0.25rem;
                    "></i>
                                </el-tooltip>
                            </span>
                        </span>
                        <span v-if="scope.row.donner_w">
                            <span>{{ scope.row.donner_w.username }}</span>
                            <span>
                                <el-tooltip class="item" effect="dark" content="分配超时" placement="top">
                                    <i class="el-icon-warning" style="
                      font-size: 0.35rem;
                      color: #f56c6c;
                      margin-left: 0.25rem;
                    "></i>
                                </el-tooltip>
                            </span>
                        </span>
                    </div>
                </template> -->
            </el-table-column>
            <!-- <el-table-column prop="urge_count" label="催办次数" width="120">
                <template slot-scope="scope">
                    <div style="padding: 0.28rem 0" v-if="scope.row.urge_count > 0">
                        <el-badge :value="scope.row.urge_count" class="item">
                            <el-button size="mini" @click="openUrgeCount(scope.row.urges)">催办次数</el-button>
                        </el-badge>
                    </div>
                </template>
            </el-table-column> -->
            <el-table-column prop="feed_count" label="反馈次数" width="80">
            </el-table-column>
            <!-- <el-table-column prop="feed[0].created_at" label="最后一次反馈时间" width="160">
                <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" content="点击查看" placement="top" v-if="scope.row.feed.length > 0">
                        <el-popover placement="right" width="300" trigger="click">
                            <el-row type="flex" class="row-bg" justify="center">
                                <el-col :span="10">反馈人:</el-col>
                                <el-col :span="14" style="font-weight: normal">
                                    {{ scope.row.feed[0].feedbacker }}
                                </el-col>
                            </el-row>
                            <el-row type="flex" class="row-bg" justify="center">
                                <el-col :span="10">反馈内容:</el-col>
                                <el-col :span="14" style="font-weight: normal">
                                    {{ scope.row.feed[0].feedback }}
                                </el-col>
                            </el-row>
                            <el-row type="flex" class="row-bg" justify="center">
                                <el-col :span="10">预计完成时间:</el-col>
                                <el-col :span="14" style="font-weight: normal">
                                    {{ scope.row.feed[0].es_time }}
                                </el-col>
                            </el-row>
                            <i slot="reference" style="cursor: pointer; font-size: 0.28rem; color: #409eff">{{
                                scope.row.feed[0].created_at }}</i>
                        </el-popover>
                    </el-tooltip>
                </template>
            </el-table-column> -->
            <el-table-column prop="type_name" label="服务类型" width="100">
            </el-table-column>
            <!-- <el-table-column prop="order_num" label="订单号" width="190">
                <template slot-scope="scope">
                    <span v-if="scope.row.order_num">
                        <el-link style="color: #409eff" @click="
                            handleOrderInfo(
                                scope.row.orderId,
                                scope.row.company.company_name
                            )
                            ">{{ scope.row.order_num }}</el-link>
                    </span>
                    <span style="color: #f56c6c" v-else>
                        <el-tooltip class="item" effect="dark" content="点击绑定订单" placement="top">
                            <el-popover @hide="clearSelf" placement="bottom" width="300" trigger="click">
                                <el-input v-model="table_OrderData" size="mini" placeholder="输入订单号绑定订单"></el-input>
                                <div style="margin-top: 0.15rem; text-align: right">
                                    <el-button type="primary" size="mini" @click="bindOrderNum(scope.row.id)">保存</el-button>
                                </div>
                                <span slot="reference" style="cursor: pointer; color: #f56c6c">无订单号</span>
                            </el-popover>
                        </el-tooltip>
                    </span>
                </template>
            </el-table-column> -->
            <el-table-column prop="title_name" label="事项" width="230">
            </el-table-column>
            <el-table-column prop="diser.username" label="分配人" width="150">
                <template slot-scope="scope">
                    <p v-if="scope.row.diser">{{ scope.row.diser.username }}</p>
                    <p>{{ scope.row.distribute_at }}</p>
                </template>
            </el-table-column>
            <el-table-column prop="progress" label="进度" width="150">
                <template slot-scope="scope">
                    <div v-if="!scope.row.overTimeD">
                        <p>{{ scope.row.progress }}</p>
                        <p v-if="scope.row.progress === '已完成'">
                            {{ scope.row.done_at }}
                        </p>
                        <p v-if="scope.row.screen.length > 0">
                            <el-link style="color: #409eff"
                                @click.native="openImageDrawer(scope.row.screen)"><span>相关截图/文件</span>
                            </el-link>
                        </p>
                    </div>
                    <div v-if="scope.row.overTimeD">
                        <p>
                            <span>{{ scope.row.progress }}</span>
                            <span>
                                <el-tooltip class="item" effect="dark" content="办理超时" placement="top">
                                    <i class="el-icon-warning" style="
                      font-size: 0.35rem;
                      color: #f56c6c;
                      margin-left: 0.25rem;
                    "></i>
                                </el-tooltip>
                            </span>
                        </p>
                        <p v-if="scope.row.progress === '已完成'">
                            {{ scope.row.done_at }}
                        </p>
                        <p v-if="scope.row.screen.length > 0">
                            <el-link @click.native="openImageDrawer(scope.row.screen)"
                                style="color: #409eff">相关截图/文件</el-link>
                        </p>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="status" label="状态" width="100">
            </el-table-column>
            <!-- <el-table-column label="操作" fixed="right" width="220">
                <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" content="编辑" placement="top">
                        <el-button @click.native.prevent="openEdit(scope.row)" type="primary" size="mini"
                            icon="el-icon-edit" circle>
                        </el-button>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="分配" placement="top">
                        <el-button @click.native.prevent="openDistribute(scope.row)" type="success" size="mini"
                            icon="el-icon-user" circle>
                        </el-button>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="" placement="top">
                        <template slot="content">
                            <p>催办</p>
                            <p>催办时间间隔为24h</p>
                        </template>
                        <el-button @click.native.prevent="openUrge(scope.row)" type="danger" size="mini"
                            icon="el-icon-message-solid" circle :disabled="(scope.row.urge.length > 0
                                ? scope.row.urge[0].notTime
                                : false) || scope.row.progress === '已完成'
                                ">
                        </el-button>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="企业微信群聊天记录" placement="top">
                        <el-button type="warning" @click="
                            handleWxChatOpen(
                                scope.row.wx_work_chat_com,
                                scope.row.company.company_name
                            )
                            " size="mini" icon="el-icon-s-comment" circle
                            :disabled="scope.row.wx_work_chat_com ? false : true">
                        </el-button>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="电话联系记录" placement="top">
                        <el-button type="primary" size="mini" icon="el-icon-phone-outline" circle
                            @click="handCallLogsOpen(scope.row)"></el-button>
                    </el-tooltip>
                </template>
            </el-table-column> -->
        </el-table>
        <div class="block" style="margin-top: 10px; text-align: right">
            <el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange" :current-page.sync="npage"
                layout="sizes, total, prev, pager, next, jumper" :total="total" :page-sizes="[10, 15, 30, 50, 100]"
                :page-size="categoryPerPage" background>
            </el-pagination>
        </div>
        <el-drawer title="公司信息" :visible.sync="companyInfoDrawer" direction="rtl"
            :before-close="handleCompanyInfoBeforeClose" size="50%" append-to-body>
            <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
                <el-row>
                    <company-info :companyId="companyComId" :checkType="pendCheckType"></company-info>
                </el-row>
            </div>
        </el-drawer>
        <el-drawer title="" :visible.sync="imageDrawer" direction="rtl" size="40%" append-to-body>
            <template slot="title">
                <span style="color: #409eff; font-size: 0.3rem">截图/文件</span>
            </template>
            <div style="padding: 0.2em 1.4em; margin-top: -17px">
                <div class="block">
                    <el-timeline>
                        <el-timeline-item placement="top">
                            <el-card>
                                <div v-for="item in imageData" :key="item.id">
                                    <div v-if="item.type === 'img'" style="margin-bottom: 0.3rem">
                                        <p style="margin-bottom: 0.28rem">
                                            <el-tooltip class="item" effect="dark" :content="item.name" placement="top">
                                                <span style="
                            display: block;
                            width: 2.5rem;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                          ">{{ item.name }}</span>
                                            </el-tooltip>
                                        </p>
                                        <p>
                                            <img @click="reSizePic(item.url)" :src="item.url" width="150px" height="150px"
                                                style="cursor: pointer" />
                                        </p>
                                    </div>
                                    <div v-if="item.type === 'file'">
                                        <p style="margin-bottom: 0.28rem">
                                            <el-tooltip class="item" effect="dark" :content="item.name" placement="top">
                                                <span style="
                            display: block;
                            width: 2.5rem;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                          " v-down="item.url">
                                                    <el-link style="color: #409eff">{{
                                                        item.name
                                                    }}</el-link>
                                                </span>
                                            </el-tooltip>
                                        </p>
                                        <!-- <p>
                          <img :src="i.url" width="150px" height="150px" />
                        </p> -->
                                    </div>
                                </div>
                            </el-card>
                        </el-timeline-item>
                    </el-timeline>
                </div>
            </div>
        </el-drawer>
        <el-dialog :visible.sync="reSizeDialog" style="text-align: center" ref="reSize">
            <img ref="rotate" width="100%" :src="this.reSizeUrl" />
            <!-- <el-button type="primary" size="mini" @click="rotate">旋转</el-button> -->
        </el-dialog>
    </div>
</template>
<script>
import upfile from '../../../common/UpFile.vue'
import Vue from 'vue'
import CompanyInfo from 'common/CompanyInfo'
import { fscDate } from '../../../../static/mixins/fastChooseDate'
import MakePhone from 'common/MakePhone'
export default {
    name: 'ComToDoList',
    mixins: [fscDate],
    components: { CompanyInfo, upfile, MakePhone },
    props: {
        matter_id: {
            type: Array
        },
    },
    data() {
        Vue.directive('down', {
            inserted: (el, binding) => {
                el.style.cssText = 'cursor: pointer;color:write;'
                el.addEventListener('click', () => {
                    // console.log(binding.value)
                    let link = document.createElement('a')
                    let image = document.createElement('image')
                    let url = binding.value
                    let downloadName = url.slice(url.lastIndexOf('/') + 1)
                    // console.log(downloadName);
                    // 这里是将url转成blob地址，
                    image.setAttribute('crossOrigin', 'anonymous') // 这句可以解决跨域问题
                    fetch(url)
                        .then((res) => res.blob())
                        .then((blob) => {
                            // 将链接地址字符内容转变成blob地址
                            link.href = URL.createObjectURL(blob)
                            // console.log(link.href)
                            link.download = downloadName
                            document.body.appendChild(link)
                            link.click()
                        })
                })
            },
        })
        let checkPhone = (rule, value, callback) => {
            if (value !== '') {
                let reg = /^1[3456789]\d{9}$/
                if (!reg.test(value)) {
                    callback(new Error('请输⼊有效的⼿机号码'))
                }
            }
            callback()
        }
        return {
            visible: false,
            reSizeUrl: '',
            pendCheckType: this.$feedBackConfig.pending_matter,
            reSizeDialog: false,
            imageData: [],
            imageDrawer: false,
            urgeCountData: [],
            urgeCountDrawer: false,
            serviceInData: [],
            value: '',
            already_expired: '',
            this_month_expired: '',
            today_renew_count: '',
            this_month_renew_count_head: '',
            companyInfoDrawer: false,
            companyInfoId: null,
            renewCompanyDrawer: false,
            renewCompanyDrawerName: '',
            wait_to_renew_company_ids: [],
            orderStatusTab: 'first',
            phoneFrom_phone: [],
            phoneFromDraw: false,
            timer: '',
            needType: '',
            companyComId: null,
            unMatterOveredId: '',
            pageSize_un: 10,
            total_un: 0,
            npage_un: 1,
            unMatterOveredData: [],
            unMatterOveredDrawer: false,
            headers: {
                Authorization: localStorage.getItem('token'),
            },
            change: false,
            aboutExId: '',
            FOptions: [],
            needUrl: [],
            fileList: [],
            limit: 10,
            distributeForm: {
                feedback: '',
                progress: '1',
            },
            examineFeed: {
                remark: '',
            },
            distributeDrawer: false,
            exmined: [],
            examine: [],
            examineId: '',
            examineDialog: false,
            pageSize_inside: 10,
            nowPage_inside: 1,
            total_inside: 0,
            npage_inside: 1,
            examineData: [],
            searchArr: {
                phone_order: '',
                created_at: '',
                salesman_id: '',
                expire_date: '',
                share_id: '',
                status: ''
            },
            adminUserOptions: [],
            npage: 1,
            categoryPerPage: 10,
            total: null,
            listSortForm: [],
            tableData: [],
            searcher: null,
            categoryEditDrawer: false,
            searchLoading: false,
            searchCategories: [],
            categoryIndrawer: false,
            direction: 'rtl',
            ifDisplay: false,
            ListIfDisplay: [],
            listSort: [],
            category: '',
            branch: [],
            options_adminUsers: [],
            typeInPickerOptions: {
                disabledDate(time) {
                    return time.getTime() < Date.now() - 3600 * 1000 * 24
                },
            },
            categoryForm: {
                name: '',
                phone: '',
                branch_id: '',
                station: '',
                meetAt: '',
                meet_place: '',
                feishuurl: '',
            },
            editCategoryForm: {
                categoryId: '',
                category_name: '',
                display: false,
            },
            rules: {
                name: [
                    { required: true, message: '请输入姓名', trigger: 'blur' },
                    {
                        min: 1,
                        max: 20,
                        message: '长度在 1 到 20 个字符',
                        trigger: 'blur',
                    },
                ],
                phone: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { validator: checkPhone, trigger: 'blur' },
                ],
                meetAt: [
                    { required: true, message: '请选择面试时间', trigger: 'blur' },
                ],
                meet_place: [
                    { required: true, message: '请选择面试地点', trigger: 'blur' },
                ],
                station: [
                    {
                        min: 1,
                        max: 20,
                        message: '长度在 1 到 20 个字符',
                        trigger: 'blur',
                    },
                ],
                feishuurl: [
                    {
                        min: 1,
                        max: 200,
                        message: '长度在 1 到 200 个字符',
                        trigger: 'blur',
                    },
                ],
            },
        }
    },
    computed: {
        collapse() {
            return this.$store.state.collapse
        },
    },
    mounted() {
        // this.loadTable()
    },
    beforeDestroy() {
        //
    },
    watch: {
        'searchArr.phone_order': {
            handler() {
                if (this.timer) {
                    clearTimeout(this.timer)
                }
                this.timer = setTimeout(() => {
                    this.npage = 1
                    this.loadTable(this.needType)
                }, 300)
            },
            deep: true,
        },
        matter_id(n) {
            this.npage = 1
            this.total = 0
            this.categoryPerPage = 10
            this.clearSome('searchArr')
            this.serviceInData = []
            if (n.length > 0) {
                // this.loadCount()
                this.loadTable()
            }
        }
    },
    methods: {
        loadCount() {
            this.value = ''
            this.already_expired = ''
            this.this_month_expired = ''
            this.today_renew_count = ''
            this.this_month_renew_count_head = ''
            this.$axios
                .get('api/ysy_count_get_company_info_count', {
                    params: {
                        company_id: this.company_id.join(','),
                        adminUserName: this.adminUserName
                    },
                })
                .then(({ data }) => {
                    if (data.code === 200) {
                        this.value = data.data.value
                        this.already_expired = data.data.already_expired
                        this.this_month_expired = data.data.this_month_expired
                        this.today_renew_count = data.data.today_renew_count
                        this.this_month_renew_count_head = data.data.this_month_renew_count_head
                    }
                })
                .catch()
        },
        loadAdminUser() {
            this.$axios
                .get('api/expmanage/getreceiver')
                .then(({ data }) => {
                    if (data.code === 1) {
                        this.adminUserOptions = data.data
                    }
                })
                .catch()
        },
        openUrl(url) {
            let newPage = this.$router.resolve({
                path: '/documentation',
                query: { url: url },
            })
            window.open(newPage.href, '_blank')
        },
        getAdminUser() {
            this.$axios.get('/api/admin/users').then((res) => {
                const { data } = res
                if (data.code === 0) {
                    this.options_adminUsers = data.data.users
                    this.roles = data.data.roles
                    this.statistical = data.data.statistical
                }
            })
        },
        getUser() {
            this.$axios.get('/api/admin/users').then((res) => {
                const { data } = res
                if (data.code === 0) {
                    this.users = data.data.users
                    this.roles = data.data.roles
                    this.branch = data.data.branch
                    this.statistical = data.data.statistical
                }
            })
        },
        copy(data) {
            // 存储传递过来的数据
            let OrderNumber = data
            // 创建一个input 元素
            // createElement() 方法通过指定名称创建一个元素
            let newInput = document.createElement('input')
            // 讲存储的数据赋值给input的value值
            newInput.value = OrderNumber
            // appendChild() 方法向节点添加最后一个子节点。
            document.body.appendChild(newInput)
            // 选中input元素中的文本
            // select() 方法用于选择该元素中的文本。
            newInput.select()
            // 执行浏览器复制命令
            //  execCommand方法是执行一个对当前文档，当前选择或者给出范围的命令
            document.execCommand('Copy')
            // 清空输入框
            newInput.remove()
            // 下面是element的弹窗 不需要的自行删除就好
            this.$message({
                message: '复制成功',
                type: 'success',
            })
        },
        copySome(data) {
            this.copy(data)
        },
        handleSizeChange_un(val) {
            // console.log(`每页 ${val} 条`)
            this.pageSize_un = val
            this.getUnMatterOveredData()
        },
        handleCurrentChange_un(val) {
            this.npage_un = val
            this.getUnMatterOveredData()
        },
        openCompanyCom_examine(row) {
            this.companyInfoDrawer = true
            setTimeout(() => {
                this.companyComId = row.company_id
            })
        },
        closeUnMatterOveredDrawer() {
            this.unMatterOveredId = ''
            this.unMatterOveredData = []
        },
        getUnMatterOveredData() {
            if (!this.unMatterOveredId) return false
            this.$axios
                .get(
                    'api/handover_examine/get_matter_un?page' +
                    this.npage_un +
                    '&perPage=' +
                    this.pageSize_un +
                    '&cid=' +
                    this.unMatterOveredId
                )
                .then(({ data }) => {
                    if (data.code === 1) {
                        this.unMatterOveredData = data.data.data
                        this.total_un = data.data.total
                    }
                })
                .catch()
        },
        openUnMatterOvered(id) {
            this.unMatterOveredId = id
            this.getUnMatterOveredData()
            this.unMatterOveredDrawer = true
        },
        beforeAvatarUpload(file) {
            // const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
            const isLt100M = file.size / 1024 / 1024 < 100

            // if (!isJPG) {
            //   this.$message.error('上传图片格式为JPG或PNG!')
            //   return
            // }
            if (!isLt100M) {
                this.$message.error('上传总大小不能超过 100MB!')
                return false
            }
            // return isJPG && isLt2M
        },
        handleAvatarSuccess(res, file) {
            if (res.code === 1) {
                this.needUrl.push({ url: res.url, name: file.name, uid: file.uid })
            }
            // this.imageUrl = URL.createObjectURL(file.raw)
        },
        handleAvatarChange(res, file) {
            this.fileList = file
            this.change = true
        },
        handlePictureCardPreview(file) {
            this.fileNameList = file.name
        },
        handleRemove(file, fileList) {
            this.needUrl.map((item, index) => {
                if (item.uid === file.uid) {
                    this.needUrl.splice(index, 1)
                }
            })
            this.fileList = fileList
            this.change = true
        },
        // 监听粘贴操作
        handlePaste(event) {
            const items = (event.clipboardData || window.clipboardData).items
            let file = null
            if (!items || items.length === 0) {
                this.$message.error('当前浏览器不支持本地')
                return
            }
            // 搜索剪切板items
            for (let i = 0; i < items.length; i++) {
                // if (items[i].type.indexOf('image') !== -1) {
                file = items[i].getAsFile()
                // break
                // }
            }
            // if (!file) {
            //   this.$message.error('粘贴内容非图片')
            //   return
            // }
            if (this.fileList.length >= this.limit) {
                this.$message.error(`上传文件数量不能超过 ${this.limit} 个!`) // 图片数量超出
                return
            }
            this.$refs.uploadMutiple.handleStart(file) // 将粘贴过来的图片加入预上传队列
            this.$refs.uploadMutiple.submit() // 提交图片上传队列
        },
        submitDisForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.distributeForm.file = this.needUrl
                    this.distributeForm.id = this.aboutExId
                    this.$axios
                        .post('api/handover_examine/store', this.distributeForm)
                        .then(({ data }) => {
                            if (data.code === 1) {
                                this.$message.success(data.msg)
                                this.distributeDrawer = false
                                this.$refs.distributeForm.resetFields()
                                this.fileList = []
                                this.needUrl = []
                                this.change = false
                                this.loadTable()
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                        .catch()
                } else {
                    return false
                }
            })
        },
        handleSizeChange_inside(val) {
            // console.log(`每页 ${val} 条`)
            this.pageSize_inside = val
            this.loadTable_inside()
        },
        handleCurrentChange_inside(val) {
            this.npage_inside = val
            this.loadTable_inside()
        },
        clearExamineParams() {
            let check = document.getElementsByTagName('input')
            let arr = Array.from(check)
            console.log(arr)
            arr.map((item) => {
                item.checked = false
            })
            // for (var i in this.examine) {
            //   this.examine[i] = false
            // }
            // this.examine.map((item, index) => {
            //   this.examine.splice(index, 1)
            // })
            this.examineId = ''
        },
        loadTable_inside() {
            this.$axios
                .get('api/handover_examine/' + this.examineId, {
                    params: {
                        page: this.npage_inside,
                        perpage: this.pageSize_inside,
                        // searchItem: this.searcher
                    },
                })
                .then(({ data }) => {
                    if (data.code === 1) {
                        this.examineData = data.data.data
                        this.total_inside = data.data.total
                        // this.loadRadio()
                        // this.loadSort()
                    }
                })
                .catch()
        },
        examineChange(val, id, index) {
            if (val) {
                this.$axios
                    .put('api/handover_examine/' + this.examineId, {
                        company_id: id,
                    })
                    .then(({ data }) => {
                        if (data.code === 1) {
                            // this.exmined.push(id)
                            // this.examineData[index].is_examined = true
                            this.loadTable_inside()
                            this.loadTable()
                            this.$message.success(data.msg)
                            //   this.examineData = data.data.data
                            //   this.total_inside = data.data.total
                            // this.loadRadio()
                            // this.loadSort()
                        }
                    })
                    .catch()
            }
        },
        openNameRow(id) {
            this.examineId = id
            this.loadTable_inside()
            this.examineDialog = true
        },
        handleClick(val) {
            if (val.name === 'first') {
                this.npage = 1
                this.needType = ''
                this.loadTable()
            }
            if (val.name === 'second') {
                this.npage = 1
                this.needType = 1
                this.loadTable(1)
            }
            if (val.name === 'third') {
                this.needType = 0
                this.npage = 1
                this.loadTable(0)
            }
        },
        openPhoneFromDraw(phone) {
            setTimeout(() => {
                this.phoneFrom_phone.push(phone)
            })
            this.phoneFromDraw = true
        },
        makePhone(phone) {
            // let regPhone = /^[1][3,4,5,6,7,8,9][0-9]{9}$/

            // if (!regPhone.test(phone)) {
            //     this.$message.error('手机号格式错误')
            //     return
            // }
            // this.$axios.post('/api/admin/call_logs/' + phone).then((res) => {
            this.$axios.post('api/admin/call_logs_call', {
                phone
            }).then((res) => {
                let { data } = res
                if (data.code === 0) {
                    this.$message.success('调用成功，请注意接听来电')
                } else {
                    this.$message.error(data.msg)
                }
            })
        },
        closePhoneFromDraw(done) {
            this.phoneFrom_phone = []
            done()
        },
        resetForm(formName) {
            this.visible = false
            this.$refs[formName].resetFields()
        },
        doSearch() {
            this.visible = false
            this.npage = 1
            this.loadTable(this.needType)
        },
        openCompanyDrawer(row, name, value) {
            this.renewCompanyDrawer = true
            this.renewCompanyDrawerName = name
            this.value = row.value
        },
        closeRenewCompanyDrawer(done) {
            this.renewCompanyDrawerName = ''
            this.wait_to_renew_company_ids = []
            done()
        },
        clearSome(obj) {
            var arr = Object.keys(this[obj])
            arr.map(item => {
                if (Array.isArray(this[obj][item])) {
                    this[obj][item] = []
                } else {
                    this[obj][item] = ''
                }
            })
        },
        loadTable() {
            this.$axios
                .get('api/ysy_count_get_matter_info', {
                    params: {
                        page: this.npage,
                        per_page: this.categoryPerPage,
                        searchItem: this.searchArr,
                        matter_id: this.matter_id.join(',')
                    },
                })
                .then(({ data }) => {
                    if (data.code === 200) {
                        this.serviceInData = data.data.data
                        // this.$refs.renewPopover.doClose()
                        this.total = data.data.total
                        // this.loadRadio()
                        // this.loadSort()
                    }
                })
                .catch()
        },
        handleCompanyInfoOpen(cid) {
            this.companyInfoDrawer = true
            setTimeout(() => {
                this.companyInfoId = cid
            })
        },
        handleCompanyInfoBeforeClose(done) {
            this.companyComId = null
            done()
        },
        loadRadio() {
            this.categoryData.map((item) => {
                if (item.display === 1) {
                    this.ListIfDisplay[item.id] = false
                } else {
                    this.ListIfDisplay[item.id] = true
                }
            })
        },
        loadSort() {
            this.categoryData.map((item) => {
                this.listSort[item.id] = Number(item.sort)
            })
        },
        handleCurrentChange(val) {
            this.npage = val
            this.loadTable(this.needType)
        },
        handleSizeChange(val) {
            this.npage = 1
            this.categoryPerPage = val
            this.loadTable()
        },
        editRow(id) {
            this.$axios
                .put('api/handover_examine/all_examined/' + id)
                .then(({ data }) => {
                    if (data.code === 1) {
                        this.$message.success(data.msg)
                        this.loadTable()
                    }
                })
                .catch()
        },
        searchRemoteCfcategory(query) {
            if (query !== '') {
                this.searchLoading = true
                setTimeout(() => {
                    this.searchLoading = false
                    this.searchItem(query)
                }, 200)
            } else {
                this.searchCategories = []
            }
        },
        searchItem(query) {
            this.$axios
                .get('api/recruit_manage_remote_search', {
                    params: {
                        search: query,
                    },
                })
                .then(({ data }) => {
                    if (data.code === 1) {
                        this.searchCategories = data.data
                    }
                })
                .catch()
        },
        handleSearchCfcategory(query) {
            this.searcher = query
            setTimeout(() => {
                this.loadTable()
            })
        },
        categoryIn() {
            this.categoryIndrawer = true
        },
        handleClose(done) {
            this.$refs.categoryForm.resetFields()
            this.$confirm('确认关闭？')
                .then((_) => {
                    done()
                })
                .catch((_) => { })
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.categoryForm.file = this.needUrl
                    this.$axios
                        .post('api/recruit_manage_store', this.categoryForm)
                        .then((res) => {
                            const { data } = res
                            if (data.code === 1) {
                                this.$message.success(data.msg)
                                this.$refs.categoryForm.resetFields()
                                this.$bus.$emit('ysyclearrm')
                                this.categoryIndrawer = false
                                this.loadTable()
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                        .catch()
                } else {
                    console.log('error submit!!')
                    return false
                }
            })
        },
        editSubmitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$axios
                        .put('api/advicecate/edit', {
                            id: this.category,
                            category_name: this.editCategoryForm.categoryId,
                            display: this.ifDisplay === false ? 1 : 0,
                        })
                        .then((res) => {
                            const { data } = res
                            if (data.code === 1) {
                                this.$message.success(data.msg)
                                this.categoryEditDrawer = false
                                this.loadTable()
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                        .catch()
                } else {
                    console.log('error submit!!')
                    return false
                }
            })
        },
        editListRadio(row) {
            this.$axios
                .put('api/advicecate/listshow', {
                    id: row.id,
                    display: this.ListIfDisplay[row.id] === false ? 1 : 0,
                })
                .then((res) => {
                    const { data } = res
                    if (data.code === 1) {
                        this.$message.success(data.msg)
                        this.loadTable()
                    } else {
                        this.$message.error(data.msg)
                    }
                })
                .catch()
        },
        setSort(row) {
            if (isNaN(this.listSort[row.id])) {
                this.$message.error('排序值为数字！')
                return false
            }
            this.$axios
                .put('api/advicecate/setsort', {
                    id: row.id,
                    sort: this.listSort[row.id],
                })
                .then((res) => {
                    const { data } = res
                    if (data.code === 1) {
                        this.$message.success(data.msg)
                        this.loadTable()
                    } else {
                        this.$message.error(data.msg)
                    }
                })
                .catch()
        },
        handleCloseDis(done) {
            this.$confirm('确认关闭？')
                .then((_) => {
                    if (this.$refs.distributeForm) {
                        this.$refs.distributeForm.resetFields()
                    }
                    this.fileList = []
                    this.needUrl = []
                    this.change = false
                    this.aboutExId = ''
                    this.distributeForm.progress = 1
                    this.FOptions = []
                    done()
                })
                .catch((_) => { })
        },
        openExamineFeed(id) {
            this.aboutExId = id
            this.$axios
                .get('api/handover_examine/' + id + '/edit')
                .then(({ data }) => {
                    if (data.code === 1) {
                        this.FOptions = data.data
                        let obj = data.data[0]
                        this.distributeForm.progress = obj ? obj.progress : 1
                    }
                })
                .catch()
            this.distributeDrawer = true
        },
        openCompanyCom(row) {
            this.companyInfoDrawer = true
            setTimeout(() => {
                this.companyComId = row.company_id
            })
        },
        openUrgeCount(data) {
            this.urgeCountData = data
            this.urgeCountData.reverse()
            this.urgeCountDrawer = true
        },
        openImageDrawer(screen) {
            this.imageData = screen
            this.imageDrawer = true
        },
        reSizePic(url) {
            this.reSizeUrl = url
            this.reSizeDialog = true
        },
    },
}
</script>
<style scoped>
.p-name {
    color: #409EFF;
}

.p-type {
    color: #67C23A;
}

.p-price {
    color: #F56C6C;
}

.count_title {
    padding: 0 0.1rem;
    color: #409EFF;
}

.count_content {
    color: #F56C6C;
    margin-right: 0.2rem;
}

.handover_examine {
    /* margin-left: 3.6rem; */
    padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}

.el-drawer__wrapper>>>.el-drawer {
    overflow-y: auto;
}

.clearfix:before,
.clearfix:after {
    display: table;
    content: '';
}

.clearfix:after {
    clear: both;
}

#forStyle>>>.demo-table-expand {
    font-size: 0;
}

#forStyle>>>.demo-table-expand label {
    width: 90px;
    color: #99a9bf;
}

#forStyle>>>.demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
    display: block;
}

#expire_date>>>.el-date-editor--datetimerange.el-input,
.el-date-editor--datetimerange.el-input__inner {
    width: 100% !important;
}
</style>
  


// WEBPACK FOOTER //
// src/pages/count/common/ToDoList.vue